var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.orientacoesIncidencia()}}},[_c('v-icon',{attrs:{"size":"22"}},[_vm._v("mdi-help-circle-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }